import { Flex } from '@sqs/rosetta-primitives';
import { useTheme } from '@sqs/rosetta-styled';
import React from 'react';
import { useI18n } from '../../i18n';
import { AcuityLoader } from './AcuityLoader';

export const LoadingSettings = () => {
  const { colors, borders, radii } = useTheme();
  const { t } = useI18n();
  return (
    <Flex
      mt={4}
      css={{
        borderRadius: radii[2],
        border: `${borders[1]} ${colors.gray['700']}`,
        width: '700px',
        padding: '60px'
      }}
      justifyContent="center"
      alignItems="center"
      aria-label={t("Loading...", {}, { project: 'enterprise-dashboard' })}>

      <AcuityLoader />
    </Flex>);

};